import React from 'react';
import { Box } from '@mui/material';
import FieldRow from './FieldRow';
import LocalizedField from './LocalizedField';
import SectionBlock from './SectionBlock';

const MEDIA_TYPE_NAMES = { 1: 'Image', 2: 'Video', 3: 'Audio' };

export default function BoothMediaDetailPanel({ data, diffKeys = new Set(), side }) {
  if (!data) return null;

  const links = Array.isArray(data.linkLocalizations) ? data.linkLocalizations : [];

  return (
    <Box>
      <SectionBlock title="Media Details" />
      <FieldRow
        label="Media Type"
        value={data.mediaTypeId != null ? (MEDIA_TYPE_NAMES[data.mediaTypeId] ?? String(data.mediaTypeId)) : null}
        isChanged={diffKeys.has('mediaTypeId')}
        side={side}
      />

      {(data.textLocalizations?.length > 0 || diffKeys.has('textLocalizations')) && (
        <LocalizedField
          label="Title"
          fieldKey="textLocalizations"
          data={data.textLocalizations}
          diffKeys={diffKeys}
          side={side}
        />
      )}

      {(data.descriptionLocalizations?.length > 0 || diffKeys.has('descriptionLocalizations')) && (
        <LocalizedField
          label="Description"
          fieldKey="descriptionLocalizations"
          data={data.descriptionLocalizations}
          diffKeys={diffKeys}
          side={side}
        />
      )}

      {links.length > 0 && (
        <>
          <SectionBlock title="Media URLs" />
          {links.map((entry) => (
            <FieldRow
              key={entry.localeId ?? entry.mediaLink}
              label={`URL (${(entry.localeId ?? '').slice(0, 2).toUpperCase() || '?'})`}
              value={entry.mediaLink ?? '—'}
              isChanged={diffKeys.has('linkLocalizations')}
              side={side}
            />
          ))}
        </>
      )}
    </Box>
  );
}
